import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';
import { useAuth } from '../context/AuthContext';

/**
 * Hook para detectar si el usuario tiene al menos una familia/grupo
 * Retorna true si tiene familia, false si no tiene ninguna
 */
export function useHasFamily() {
  const { user } = useAuth();
  const [hasFamily, setHasFamily] = useState<boolean | null>(null); // null = loading
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setHasFamily(false);
      setLoading(false);
      return;
    }

    // Escuchar cambios en tiempo real
    const q = query(
      collection(db, 'families'),
      where('members', 'array-contains', user.uid)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      setHasFamily(snapshot.docs.length > 0);
      setLoading(false);
    }, (error) => {
      console.error('Error checking families:', error);
      setHasFamily(false);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [user]);

  return { hasFamily, loading };
}
